<div class="container">
    <div class="error-image">
    </div>
    <div style="text-align: center; color: #666">
      <h2>{{ errorMessage }}</h2>
</div>
</div>
